<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="430px"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
    >
        <div v-if="progressData.title" slot="title" class="progressTitle">
            {{ progressData.title }}
        </div>
        <div class="custom">
            <span>{{ progressData.taskName }}</span>
            <el-progress class="mt10" :percentage="progressData.percentage" color="#2770fa" :stroke-width="12" />
            <span v-if="progressData.message" class="mt10">{{ progressData.message }}</span>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                v-for="(item, index) in progressData.btnArr"
                :key="index"
                :type="item.type"
                @click="btnHanle(item)"
            >
                {{ item.name }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
// const defaultBtn = [
//     {
//         name: '取 消',
//         type: '',
//         autoClose: true, // 点击按钮的时候 是否自动关闭进度条
//         callback: () => {
//             this.dialogVisible = false;
//         },
//     },
//     {
//         name: '后台运行',
//         type: 'primary',
//         autoClose: false, // 点击按钮的时候 是否自动关闭进度条
//         callback: () => {
//             this.dialogVisible = false;
//         },
//     },
// ];
let options = {};
let loading;
let meterTime;
let roundTime;
let getResultTimeout = null;
export default {
    name: 'ProgressAss',
    data() {
        return {
            dialogVisible: false,
            isOpen: true, // 如果false 就不接收 推送消息
            progressData: {
                title: '进度',
                taskId: '',
                taskName: '正在修改中',
                message: '',
                percentage: 0,
                isFake: false,
                speed: 15,
                btnArr: [],
            },
            judgeRoundRobin: false, // 判断有没有走轮循
        };
    },
    watch: {
        'progressData.percentage': {
            handler(percentage) {
                if (options.isOnlyShowBar) {
                    options.callBack && options.callBack(percentage, this);
                }
            },
        },
    },
    mounted() {},
    methods: {
        init() {
            this.dialogVisible = false;
            this.judgeRoundRobin = false;
            this.progressData.taskId = '';
            this.progressData.title = '';
            this.progressData.percentage = 0;
            this.progressData.message = '';
            this.progressData.btnArr = [];
            this.taskName = '';
        },
        takeTurns() {
            meterTime = setTimeout(() => {
                this.judgeRoundRobin = true;
                this.roundRobin();
            }, 10000);
        },
        // 轮循
        roundRobin() {
            this.$ajax
                .post('app/ali/getbgtask', { taskId: this.progressData.taskId })
                .then((data) => {
                    loading.close();
                    if (data.Success === false) {
                        this.$message.warning(data.Tips || '请求失败，请稍后重试！');
                        return;
                    }
                    this.judgeProcess(data.Data);
                })
                .catch(() => {
                    loading.close();
                });
        }, // 判断进度
        judgeProcess(data) {
            meterTime && clearTimeout(meterTime);
            roundTime && clearTimeout(roundTime);
            if (!this.isOpen) {
                return;
            }
            if (data.State == 0) {
                // 等待中
                this.dialogVisible = true;
                this.progressData.message = '当前操作人数较多，正在排队中，请稍后';
                if (!this.judgeRoundRobin) {
                    this.takeTurns();
                } else {
                    roundTime = setTimeout(() => {
                        this.roundRobin();
                    }, 3000);
                }
            } else if (data.State == 1) {
                if (this.progressData.isFake) {
                    if (data.Progress >= 100) {
                        this.progressData.percentage = 100;
                    } else if (this.progressData.percentage >= 90) {
                        this.progressData.percentage = 99;
                    } else {
                        this.progressData.percentage += this.progressData.speed;
                    }
                } else {
                    this.progressData.percentage = data.Progress >= 100 ? 100 : data.Progress;
                }
                this.progressData.message = data.Message;
                this.dialogVisible = true;
                if (!this.judgeRoundRobin) {
                    this.takeTurns();
                } else {
                    roundTime = setTimeout(
                        () => {
                            this.roundRobin();
                        },
                        window.DZ_CONFIGURE ? window.DZ_CONFIGURE.PROGRESS_POLLING_TIME : 5000
                    );
                }
            } else if (data.State == 2) {
                this.progressData.percentage = 100;
                if (getResultTimeout) {
                    clearTimeout(getResultTimeout);
                }
                getResultTimeout = setTimeout(() => {
                    this.$ajax
                        .post('app/ali/getbgtask', { taskId: this.progressData.taskId })
                        .then((taskInfo) => {
                            clearTimeout(getResultTimeout);
                            loading.close();
                            this.dialogVisible = false;
                            if (options.callBack != undefined) {
                                const result = JSON.parse(taskInfo.Data.Result);
                                result.taskId = this.progressData.taskId;
                                options.callBack(result);
                            }
                        })
                        .catch(() => {
                            clearTimeout(getResultTimeout);
                            loading.close();
                        });
                }, 500);
            } else if (data.State == 3) {
                // 异常
                setTimeout(() => {
                    this.$ajax
                        .post('app/ali/getbgtask', { taskId: this.progressData.taskId })
                        .then((taskInfo) => {
                            loading.close();
                            this.dialogVisible = false;
                            if (options.callBack != undefined) {
                                const result = JSON.parse(taskInfo.Data.Result);
                                result.taskId = this.progressData.taskId;
                                options.callBack(result);
                            }
                        })
                        .catch(() => {
                            loading.close();
                        });
                }, 3000);
            }
        },
        startDazeTask(taskId) {
            this.progressData.taskId = taskId;
            meterTime && clearTimeout(meterTime);
            this.takeTurns();
            const that = this;
            dazeTask.register(taskId, (data) => {
                if (!that.isOpen) {
                    return;
                }
                loading.close();
                that.dialogVisible = true;
                that.judgeRoundRobin = false;
                that.judgeProcess(data);
            });
        },
        btnHanle(item) {
            meterTime && clearTimeout(meterTime);
            roundTime && clearTimeout(roundTime);
            this.isOpen = false;
            if (item.autoClose == undefined || item.autoClose) {
                this.dialogVisible = false;
            }
            item.callback && item.callback(this);
        },
        show(_options) {
            options = {
                percentage: 0,
                title: '进度',
                text: '数据加载中',
                url: '',
                taskId: '',
                taskName: '正在修改中',
                data: {},
                btns: [],
                isOnlyShowBar: false, // 是否展示纯净度
                callBack: undefined,
                message: '',
            };
            options = Object.assign(options, _options);
            this.init();
            this.judgeRoundRobin = false;
            this.progressData.title = options.title;
            this.progressData.text = options.text;
            this.progressData.btnArr = options.btns;
            this.progressData.percentage = options.percentage;
            this.progressData.isFake = !!options.isFake;
            this.progressData.speed = options.speed || 15;
            this.progressData.taskName = options.taskName;
            this.progressData.message = options.message;
            this.isOpen = true;
            if (options.isOnlyShowBar) {
                this.dialogVisible = true;
                return;
            }
            loading = this.$loading({
                fullscreen: true,
                text: options.text,
                background: 'rgba(0, 0, 0, 0.1)',
            });
            if (options.taskId !== '') {
                this.startDazeTask(options.taskId);
                return;
            }
            this.$ajax
                .post(options.url, options.data)
                .then((getTaskId) => {
                    if (getTaskId.msg || getTaskId.Msg) {
                        // 新接口返回的数据结构
                        // 新接口返回的参数
                        var message = getTaskId.msg || getTaskId.Msg;
                        var code = getTaskId.code || getTaskId.Code;
                        var result = getTaskId.result || getTaskId.Result;
                        if (code == 200) {
                            // 正常执行任务
                            this.startDazeTask(result);
                        } else {
                            // 有任务在执行
                            loading.close();
                            this.$message({
                                message: message,
                                type: 'warning',
                            });
                            setTimeout(() => {
                                loading = this.$loading({
                                    fullscreen: true,
                                    text: options.text,
                                    background: 'rgba(0, 0, 0, 0.1)',
                                });
                                this.startDazeTask(result);
                            }, 3000);
                        }
                    } else {
                        // 旧接口
                        // eslint-disable-next-line no-lonely-if
                        if (!getTaskId.Data) {
                            // 没有任务id说明是任务创建失败
                            loading.close();
                            this.$message({
                                message: getTaskId.Tips,
                                type: 'warning',
                            });
                        } else if (getTaskId.Success) {
                            // 正常执行任务
                            this.startDazeTask(getTaskId.Data);
                        } else {
                            // 有任务在执行
                            loading.close();
                            this.$message({
                                message: getTaskId.Tips,
                                type: 'warning',
                            });
                            setTimeout(() => {
                                loading = this.$loading({
                                    fullscreen: true,
                                    text: options.text,
                                    background: 'rgba(0, 0, 0, 0.5)',
                                });
                                this.startDazeTask(getTaskId.Data);
                            }, 3000);
                        }
                    }
                })
                .catch(() => {
                    loading.close();
                });
        },
        close() {
            // this.init();
            this.dialogVisible = false;
            this.$nextTick(() => {
                this.judgeRoundRobin = false;
                this.progressData.taskId = '';
                this.progressData.title = '';
                this.progressData.percentage = 0;
                this.progressData.message = '';
                this.progressData.btnArr = [];
                this.taskName = '';
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.custom {
    span {
        display: block;
        max-width: 100%;
        color: #444;
        word-break: break-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
.colorff {
    color: #fff;
}
.progressTitle {
    font-size: 16px;
    font-weight: 400;
}
</style>
